import $ from 'jquery';

const popup = $('.DiscountModal');

const showPopup = () => {
    popup.addClass('open');
};

$(window).on('load', () => {
    if (popup.length) {
        popup.addClass('ready');

        const hasShown = sessionStorage.getItem('hasSeenDiscountModal');

        if (!hasShown) {
            setTimeout(() => {
                showPopup();
            }, 5000);
        }
    }
});

const hidePopup = () => {
    popup.removeClass('open');
};

$('.DiscountModal').on('click', hidePopup);

$('.DiscountModal__inner').on('click', function (ev) {
    ev.preventDefault();
    ev.stopImmediatePropagation();
});

$('.DiscountModal__continue, .SidebarCart__close ').on('click', hidePopup);

$('#close-discount-modal-button').on('click', function (e) {
    e.preventDefault();

    hidePopup();

    const discountCode = $(this).data('value');

    sessionStorage.setItem('hasSeenDiscountModal', 'true');

    if (discountCode) {
        navigator.clipboard.writeText(discountCode).then(() => {
            console.log(`Kod rabatowy "${discountCode}" został skopiowany do schowka.`);
        });
    }
});
